/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Modules_InvestorInputs */

const cs_clients_modules_investor = /** @type {(inputs: Clients_Modules_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investorský profil`)
};

const en_clients_modules_investor = /** @type {(inputs: Clients_Modules_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investor profile`)
};

/**
* | output |
* | --- |
* | "Investor profile" |
*
* @param {Clients_Modules_InvestorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_modules_investor = /** @type {((inputs?: Clients_Modules_InvestorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Modules_InvestorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_modules_investor(inputs)
	return cs_clients_modules_investor(inputs)
});